export const SET_LAST_TASK_ID = 'SET_LAST_TASK_ID';
export const SET_TASK_OFFERS_FETCHING_FLAG = 'SET_TASK_OFFERS_FETCHING_FLAG';
export const SET_TASK_UPDATE_ERROR = 'SET_TASK_UPDATE_ERROR';
export const SET_TASK_UPDATE_FETCHING_FLAG = 'SET_TASK_UPDATE_FETCHING_FLAG';
export const SET_TASK_UPDATE_STATUS = 'SET_TASK_UPDATE_STATUS';
